module.exports = __webpack_public_path__ + "static/media/de05.b6c23bbb.jpg";